import React, { useEffect, useState } from "react";
import "../App.css";
import Nav from "./Navigation.js";
import { useNavigate } from "react-router-dom";
import { getTokenInternal } from "./useToken";

export default function AllListedItems() {
  const [allItems, setAllItems] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState("");
  const [itemVisibility, setItemVisibility] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [token, setToken] = useState();

  const fetchData = async () => {
    const url = `${process.env.REACT_APP_API_HOST}/api/items`;
    const response = await fetch(url);
    const completeList = await response.json();
    setAllItems(completeList);
  };

  useEffect(() => {
    fetchData();
  }, []);


   useEffect(() => {
     const fetchToken = async () => {
       try {
         const fetchedToken = await getTokenInternal();
         setToken(fetchedToken);
       } catch (error) {
         console.error("Error fetching token:", error);
       }
     };

     fetchToken();
   }, []);

   useEffect(() => {
     if (token) {
     }
   }, [token]);


  const handleEventSelection = (e) => {
    const selectedValue = e.target.value;
    setSelectedEvent(selectedValue);
    }

  const handleClearSelection = () => {
    setSelectedEvent("");
    setSearchTerm("");
  };

  const toggleVisibility = (itemName) => {
    setItemVisibility((prevVisibility) => ({
      ...prevVisibility,
      [itemName]: !prevVisibility[itemName],
    }));
  };
  const navigate = useNavigate();

  const handleEditItem = (item) => {
    const editRoute = `/edit/${item.id}`;
    navigate(editRoute, { state: { itemData: item } });
  };

const selectedEvents = allItems.filter((item) => {
  if (
    selectedEvent === "" &&
    (searchTerm === "" ||
      item.name.toLowerCase().includes(searchTerm.toLowerCase()))
  ) {
    return true;
  } else {
    return (
      item.event === selectedEvent &&
      (searchTerm === "" ||
        item.name.toLowerCase().includes(searchTerm.toLowerCase()))
    );
  }
});

const handleDeleteItem = async (filteredItem) => {
  try {
    const url = `${process.env.REACT_APP_API_HOST}/api/items/${filteredItem.id}`;
    const response = await fetch(url, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token.access_token}`,
      },
    });

    if (response.ok) {
      // Remove the deleted item from the state
      setAllItems((prevItems) =>
        prevItems.filter((item) => item.id !== filteredItem.id)
      );
    } else {
      console.error("Failed to delete item:", response.statusText);
    }
  } catch (error) {
    console.error("Error deleting item:", error);
  }
};

  return (
    <div>
      <Nav />
      <div className="text-white">
        <div className="Title">Complete List of Items</div>
        <div className="mb-4">
          <label htmlFor="eventDropdown" className="text-md font-bold">
            Select Event:
          </label>
          <select
            id="eventDropdown"
            onChange={handleEventSelection}
            value={selectedEvent}
            className="ml-2 p-1 border rounded text-black"
          >
            <option value="">All</option>
            {Array.from(new Set(allItems.map((item) => item.event))).map(
              (event) => (
                <option key={event} value={event}>
                  {event}
                </option>
              )
            )}
          </select>
          Or search
          <input
            type="text"
            placeholder="Search by name..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="ml-2 p-1 border rounded text-black"
          />
          <button
            onClick={handleClearSelection}
            className="ml-2 p-1 border rounded"
          >
            Reset/Clear
          </button>
        </div>

        <div className="flex">
          {Array.from(
            new Set(
              selectedEvents
                .sort((a, b) => a.name.localeCompare(b.name))
                .map((item) => item.maps)
            )
          ).map((map) => (
            <div key={map} className="mb-6 ml-2">
              <h3 className="text-lg font-bold mb-2">{map} Maps</h3>
              {Array.from(
                new Set(
                  selectedEvents
                    .filter((item) => item.maps === map)
                    .sort((a, b) => a.name.localeCompare(b.name))
                    .map((item) => item.types)
                )
              ).map((type) => (
                <div key={type} className="mb-4">
                  <h4 className="text-md font-bold mb-2">{type} Types</h4>
                  <div className="grid gap-2">
                    {selectedEvents
                      .filter(
                        (item) => item.maps === map && item.types === type
                      )
                      .map((filteredItem) => (
                        <div
                          className={`border p-1 rounded ${
                            filteredItem.checked
                              ? "bg-green-500"
                              : "bg-neutral-400"
                          } flex items-center`}
                          key={filteredItem.user_item_id}
                        >
                          <div className="flex">
                            <div>{filteredItem.name}</div>
                          </div>
                          <button
                            className="ml-2 bg-blue-500 border-solid border-2 border-white text-white px-1 py-0 rounded"
                            onClick={() => toggleVisibility(filteredItem.name)}
                          >
                            {itemVisibility[filteredItem.name]
                              ? "Hide"
                              : "Info"}
                          </button>
                          {itemVisibility[filteredItem.name] && (
                            <div className="mt-2">
                              <div className="flex">
                                <div> Map: </div>
                                <div className="ml-2">
                                  {filteredItem.maps_name}
                                </div>
                              </div>
                              <img
                                    className="object-scale-down h-48 cursor-pointer"
                                    src={`/imagesitems/${filteredItem.url}`}
                                    alt="Description of the image"
                                    onError={(e) => {
                                      e.target.src = '/gamelogos/Unofficial.PNG'; // Set fallback image on error
                                    }}
                                  />
                            </div>
                          )}
                          {token &&
                            (token.account.role === "management" ||
                              token.account.role === "owner") && (
                              <button
                                type="button"
                                className="ml-2 bg-blue-500 border-solid border-2 border-white text-white px-1 py-0 rounded"
                                onClick={() => handleEditItem(filteredItem)}
                              >
                                Edit
                              </button>
                            )}
                          {token &&
                            (token.account.role === "management" ||
                              token.account.role === "owner") && (
                              <button
                                type="button"
                                className="ml-2 bg-red-500 border-solid border-2 border-white text-white px-1 py-0 rounded"
                                onClick={() => handleDeleteItem(filteredItem)}
                              >
                                Delete
                              </button>
                            )}
                        </div>
                      ))}
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

// import React, { useEffect, useState } from "react";
// import "../App.css";
// import Nav from "./Navigation.js";
// import { useNavigate } from "react-router-dom";
// import { getTokenInternal } from "./useToken";

// export default function AllListedItems() {
//   const [allItems, setAllItems] = useState([]);
//   const [selectedEvent, setSelectedEvent] = useState("");
//   const [itemVisibility, setItemVisibility] = useState({});
//   const [searchTerm, setSearchTerm] = useState("");
//   const [token, setToken] = useState();

//   const fetchData = async () => {
//     const url = `${process.env.REACT_APP_API_HOST}/api/items`;
//     const response = await fetch(url);
//     const completeList = await response.json();
//     setAllItems(completeList);
//   };

//   useEffect(() => {
//     fetchData();
//   }, []);


//    useEffect(() => {
//      const fetchToken = async () => {
//        try {
//          const fetchedToken = await getTokenInternal();
//          setToken(fetchedToken);
//        } catch (error) {
//          console.error("Error fetching token:", error);
//        }
//      };

//      fetchToken();
//    }, []);

//    useEffect(() => {
//      if (token) {
//      }
//    }, [token]);


//   const handleEventSelection = (e) => {
//     const selectedValue = e.target.value;
//     setSelectedEvent(selectedValue);
//     }

//   const handleClearSelection = () => {
//     setSelectedEvent("");
//     setSearchTerm("");
//   };

//   const toggleVisibility = (itemName) => {
//     setItemVisibility((prevVisibility) => ({
//       ...prevVisibility,
//       [itemName]: !prevVisibility[itemName],
//     }));
//   };
//   const navigate = useNavigate();

//   const handleEditItem = (item) => {
//     const editRoute = `/edit/${item.id}`;
//     navigate(editRoute, { state: { itemData: item } });
//   };

// const selectedEvents = allItems.filter((item) => {
//   if (
//     selectedEvent === "" &&
//     (searchTerm === "" ||
//       item.name.toLowerCase().includes(searchTerm.toLowerCase()))
//   ) {
//     return true;
//   } else {
//     return (
//       item.event === selectedEvent &&
//       (searchTerm === "" ||
//         item.name.toLowerCase().includes(searchTerm.toLowerCase()))
//     );
//   }
// });

// const handleDeleteItem = async (filteredItem) => {
//   try {
//     const url = `${process.env.REACT_APP_API_HOST}/api/items/${filteredItem.id}`;
//     const response = await fetch(url, {
//       method: "DELETE",
//       headers: {
//         "Content-Type": "application/json",
//         Authorization: `Bearer ${token.access_token}`,
//       },
//     });

//     if (response.ok) {
//       // Remove the deleted item from the state
//       setAllItems((prevItems) =>
//         prevItems.filter((item) => item.id !== filteredItem.id)
//       );
//     } else {
//       console.error("Failed to delete item:", response.statusText);
//     }
//   } catch (error) {
//     console.error("Error deleting item:", error);
//   }
// };

//   return (
//     <div>
//       <Nav />
//       <div className="text-white">
//         <div className="Title">Complete List of Items</div>
//         <div className="mb-4">
//           <label htmlFor="eventDropdown" className="text-md font-bold">
//             Select Event:
//           </label>
//           <select
//             id="eventDropdown"
//             onChange={handleEventSelection}
//             value={selectedEvent}
//             className="ml-2 p-1 border rounded text-black"
//           >
//             <option value="">All</option>
//             {Array.from(new Set(allItems.map((item) => item.event))).map(
//               (event) => (
//                 <option key={event} value={event}>
//                   {event}
//                 </option>
//               )
//             )}
//           </select>
//           Or search
//           <input
//             type="text"
//             placeholder="Search by name..."
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//             className="ml-2 p-1 border rounded text-black"
//           />
//           <button
//             onClick={handleClearSelection}
//             className="ml-2 p-1 border rounded"
//           >
//             Reset/Clear
//           </button>
//         </div>

//         <div className="flex">
//           {Array.from(
//             new Set(
//               selectedEvents
//                 .sort((a, b) => a.name.localeCompare(b.name))
//                 .map((item) => item.maps)
//             )
//           ).map((map) => (
//             <div key={map} className="mb-6 ml-2">
//               <h3 className="text-lg font-bold mb-2">{map} Maps</h3>
//               {Array.from(
//                 new Set(
//                   selectedEvents
//                     .filter((item) => item.maps === map)
//                     .sort((a, b) => a.name.localeCompare(b.name))
//                     .map((item) => item.types)
//                 )
//               ).map((type) => (
//                 <div key={type} className="mb-4">
//                   <h4 className="text-md font-bold mb-2">{type} Types</h4>
//                   <div className="grid grid-cols-1 gap-2">
//                     {selectedEvents
//                       .filter(
//                         (item) => item.maps === map && item.types === type
//                       )
//                       .map((filteredItem) => (
//                         <div
//                           className={`border p-1 rounded ${
//                             filteredItem.checked
//                               ? "bg-green-500"
//                               : "bg-neutral-400"
//                           } flex items-center`}
//                           key={filteredItem.user_item_id}
//                         >
//                           <div className="flex">
//                             <div>{filteredItem.name}</div>
//                           </div>
//                           <button
//                             className="ml-2 bg-blue-500 border-solid border-2 border-white text-white px-1 py-0 rounded"
//                             onClick={() => toggleVisibility(filteredItem.name)}
//                           >
//                             {itemVisibility[filteredItem.name]
//                               ? "Hide"
//                               : "Info"}
//                           </button>
//                           {itemVisibility[filteredItem.name] && (
//                             <div className="mt-2">
//                               <div className="flex">
//                                 <div> Map: </div>
//                                 <div className="ml-2">
//                                   {filteredItem.maps_name}
//                                 </div>
//                               </div>
//                               <img
//                                 src={filteredItem.url}
//                                 alt={"Sorry, no picture available"}
//                                 className="max-w-full"
//                               />
//                             </div>
//                           )}
//                           {token &&
//                             (token.account.role === "management" ||
//                               token.account.role === "owner") && (
//                               <button
//                                 type="button"
//                                 className="ml-2 bg-blue-500 border-solid border-2 border-white text-white px-1 py-0 rounded"
//                                 onClick={() => handleEditItem(filteredItem)}
//                               >
//                                 Edit
//                               </button>
//                             )}
//                           {token &&
//                             (token.account.role === "management" ||
//                               token.account.role === "owner") && (
//                               <button
//                                 type="button"
//                                 className="ml-2 bg-red-500 border-solid border-2 border-white text-white px-1 py-0 rounded"
//                                 onClick={() => handleDeleteItem(filteredItem)}
//                               >
//                                 Delete
//                               </button>
//                             )}
//                         </div>
//                       ))}
//                   </div>
//                 </div>
//               ))}
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// }
